export default __webpack_public_path__ + "static/media/carpentry.caea342c.png";